import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CtPage } from '../../../model/ct-batch-model';
import { PageImageService } from '../../../batch-api/page-image.service';

@Component({
  selector: 'ct-shared-preview-page-thumbnail',
  imports: [NgClass],
  templateUrl: './preview-page-thumbnail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewPageThumbnailComponent {
  readonly selected = input.required<boolean>();
  readonly index = input.required<number>();
  readonly page = input.required<CtPage>();

  protected readonly pageImageService = inject(PageImageService);
}
